/** Add Route Component */
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "../components/TermsConditions/TermsConditions";
import Layout1 from "../pages/Layout1/Layout1";
import Layout2 from "../pages/Layout2/Layout2";
import Layout3 from "../pages/Layout3/Layout3";
import Layout4 from "../pages/Layout4/Layout4";
import Layout5 from "../pages/Layout5/Layout5";
import Layout6 from "../pages/Layout6/Layout6";
import LandingPage from "../sample/sme_portal_landing_page";

interface RouteProps {
  path: string;
  component?: any;
  exact?: boolean;
}

export const MainRoutes: Array<RouteProps> = [
  { path: "/", component: <Layout2 /> },
  { path: "/", component: <Layout2 /> },
  { path: "/layout5", component: <Layout5 /> },
  { path: "/layout4", component: <Layout4 /> },
  { path: "/layout3", component: <Layout3 /> },
  { path: "/layout2", component: <Layout2 /> },
  { path: "/layout1", component: <Layout1 /> },
  { path: "/layout0", component: <Layout1 /> },
  { path: "/sample", component: <LandingPage /> },
];

export const ExternalRoutes: Array<RouteProps> = [
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/terms-conditions", component: <TermsConditions /> },
]

// export { Routes, ExternalRouter };